import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {onMounted} from 'vue';
import {getRedirectUrlApi} from '@/api/labelApis';
import {useRoute, useRouter} from 'vue-router';

export default /*#__PURE__*/_defineComponent({
  __name: '404View',
  setup(__props) {

const route = useRoute()
const router = useRouter()
onMounted(async () => {
  const { url } = await getRedirectUrlApi(route.path)
  if (url) {
    await router.replace(url)
  } else {
    await router.replace({name: 'HomeView'})
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div"))
}
}

})